import React from 'react';
import LoginModal from './init/LoginModal';

//页面根组件
class Root extends React.Component {
  render() {
    return (
      <div style={{height: '100%'}}>
        {this.props.children}
        <LoginModal />
      </div>
    )
  }
}

export default Root;


// WEBPACK FOOTER //
// ./src/components/Root.js